<script>
	import UserCreateForm from "./UserCreateForm.svelte";
	export let userId;
</script>

<UserCreateForm isEdit={userId} />
